import styled from 'styled-components';
import Stack from '@karma/components/Stack';
import { getColor } from '@karma/components/colors';
import TagImage from 'components/atoms/TagImage/TagImage';

export const Wrapper = styled(Stack)`
  overflow: hidden;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  background-color: ${getColor('neutral8')};
`;

export const HeightController = styled.div`
  margin-top: 120%;
  width: 100%;
`;

export const ContentWrapper = styled(Stack)`
  padding: 8px;
`;

export const StyledTagImage = styled(TagImage)`
  position: absolute;
  top: 0;
  left: 0;
`;
